import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

@Injectable()
export abstract class BaseFacade {
    protected readonly store$: Store = inject(Store);
}
